module.exports = __webpack_public_path__ + "static/media/redX.82568a21.svg";